import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "@/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturnPage() {
  const [params] = useSearchParams();
  const { authHeaders } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState({ status: "checking", payment: null, tries: 0 });
  const payment_id = params.get("payment_id");

  useEffect(() => {
    if (!payment_id) { setState({ status: "error" }); return; }
    let cancelled = false;
    const poll = async (n = 0) => {
      if (cancelled) return;
      try {
        const { data } = await axios.get(`${API}/payments/${payment_id}/status`, { headers: authHeaders() });
        if (data.status === "paid") { setState({ status: "paid", payment: data }); return; }
        if (data.status === "failed") { setState({ status: "failed", payment: data }); return; }
        if (n < 8) setTimeout(() => poll(n + 1), 2000);
        else setState({ status: "pending", payment: data });
      } catch (e) {
        if (n < 5) setTimeout(() => poll(n + 1), 2000);
        else setState({ status: "error" });
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [payment_id]);

  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center fade-in">
      {state.status === "checking" && (
        <>
          <Loader2 className="h-16 w-16 text-blue-600 mx-auto animate-spin" />
          <h1 className="text-2xl font-bold mt-4">Ödəniş yoxlanılır...</h1>
          <p className="text-slate-500 mt-2">Payriff-dən təsdiq gözlənilir</p>
        </>
      )}
      {state.status === "paid" && (
        <>
          <CheckCircle2 className="h-16 w-16 text-emerald-500 mx-auto" />
          <h1 className="text-2xl font-bold mt-4" data-testid="payment-success">Ödəniş uğurlu!</h1>
          <p className="text-slate-500 mt-2">Auksionunuz aktivləşdirildi</p>
          <Link to="/dashboard"><Button className="mt-6 rounded-full bg-blue-600 hover:bg-blue-700 h-12 px-8 font-semibold">İdarəetməyə keç</Button></Link>
        </>
      )}
      {state.status === "failed" && (
        <>
          <XCircle className="h-16 w-16 text-red-500 mx-auto" />
          <h1 className="text-2xl font-bold mt-4">Ödəniş uğursuz oldu</h1>
          <p className="text-slate-500 mt-2">Yenidən cəhd edə bilərsiniz</p>
          <Button onClick={() => nav("/sell")} className="mt-6 rounded-full bg-blue-600 hover:bg-blue-700 h-12 px-8 font-semibold">Yenidən başla</Button>
        </>
      )}
      {state.status === "pending" && (
        <>
          <Loader2 className="h-16 w-16 text-amber-500 mx-auto" />
          <h1 className="text-2xl font-bold mt-4">Ödəniş hələ təsdiqlənməyib</h1>
          <p className="text-slate-500 mt-2">Bir neçə dəqiqə sonra idarəetmə panelini yoxlayın</p>
          <Link to="/dashboard"><Button className="mt-6 rounded-full">İdarəetməyə keç</Button></Link>
        </>
      )}
      {state.status === "error" && (
        <>
          <XCircle className="h-16 w-16 text-red-500 mx-auto" />
          <h1 className="text-2xl font-bold mt-4">Xəta baş verdi</h1>
          <Link to="/dashboard"><Button className="mt-6 rounded-full">İdarəetməyə keç</Button></Link>
        </>
      )}
    </div>
  );
}
